import { useCallback, useState } from "react";

/**
 * Seleção múltipla por id (ex.: patientId). Usado nas tabelas de pacientes do CRM comunicações.
 * toggleAll: se todos os ids informados já estiverem selecionados, limpa; caso contrário seleciona o conjunto inteiro.
 */
export function useSetSelection() {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(() => new Set());

  const toggle = useCallback((id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback((allIds: readonly string[]) => {
    setSelectedIds((prev) => {
      const list = [...allIds];
      const allIn =
        list.length > 0 && list.every((id) => prev.has(id));
      if (allIn) return new Set();
      return new Set(list);
    });
  }, []);

  const clear = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  const has = useCallback(
    (id: string) => selectedIds.has(id),
    [selectedIds],
  );

  return {
    selectedIds,
    selectedCount: selectedIds.size,
    toggle,
    toggleAll,
    clear,
    has,
  };
}
